import * as yup from "yup";

import { strongPassword } from "./utils";

export function changePasswordSchema() {
  yup.addMethod(yup.mixed, "strongPassword", strongPassword);

  return yup
    .object({
      isShowSMS: yup.boolean(),
      isShowApp: yup.boolean(),

      appCode: yup.string().when("isShowApp", {
        is: (isShowApp) => isShowApp === true,
        then: yup
          .string()
          .required("وارد کردن کد الزامی است.")
          .min(6, "کد وارد شده باید 6 رقم باشد")
          .max(6, "کد وارد شده باید 6 رقم باشد"),
      }),

      emailCode: yup
        .string()
        .required("وارد کردن کد ایمیل شده الزامی است.")
        .min(6, "کد وارد شده باید 6 رقم باشد")
        .max(6, "کد وارد شده باید 6 رقم باشد"),

      smsCode: yup.string().when("isShowSMS", {
        is: (isShowSMS) => isShowSMS === true,
        then: yup
          .string()
          .required("وارد کردن کد ارسالی الزامی است.")
          .min(6, "کد وارد شده باید 6 رقم باشد")
          .max(6, "کد وارد شده باید 6 رقم باشد"),
      }),
      oldPassword: yup.string().required("وارد کردن رمز عبور فعلی الزامی است."),

      newPassword: yup
        .string()
        .required("وارد کردن رمز عبور جدید الزامی است.")
        .strongPassword(),

      confirmPassword: yup
        .string()
        .required("وارد کردن تکرار رمز عبور جدید الزامی است.")
        .oneOf(
          [yup.ref("newPassword"), null],
          "تایید رمز عبور با رمز عبور جدید تطابق ندارند"
        ),
    })
    .required();
}
